import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'

import {TravelList} from './travellist.component'
import {TravelChoice} from './travelchoice.component'
import {TravelSearch} from './travelsearch.component'
import {TravelEntry} from './travelentry.component'

export class TravelOverview extends React.Component {
    constructor(props) {
        super(props)    

        this.state = {
            hasTravel: this.props.hasTravel
        }

        _.bindAll(this,
            'getContent'
        )
    }

    getContent() {
    // console.log('TRAVEL Section: '+this.props.detailSubSection+":"+this.props.detailSubDetail)
        switch (this.props.detailSubSection) {
            case this.props.availableDetailSubSections.OVERVIEW:
                return <TravelList 
                  {...this.props}/>
            case this.props.availableDetailSubSections.CHOICE:
                return <TravelChoice 
                  {...this.props}/>
            case this.props.availableDetailSubSections.SEARCH:
                return <TravelSearch 
                  {...this.props}/>
            case this.props.availableDetailSubSections.ENTRY:
                return <TravelEntry 
                   {...this.props}/>
            case this.props.availableDetailSubSections.DETAILS:
                return 'Overview of Travel Item'
            case this.props.availableDetailSubSections.AGENT:
                return 'probably an expanded note form here'
        }
    }

    render() {
        let showContent = this.getContent()

        return (
            <div>
                {showContent}
            </div>
        )
    }
}